import { Skeleton } from 'antd';
import { get, last } from 'lodash';
import React, { useMemo } from 'react';
import { getAppSyncError } from '../../../apollo';
import { ChartRequestError } from '../ChartRequestError';
export const ChartDataLoader = ({ dataResult, dataPath, className, chartType, children, }) => {
    const parsedResult = useMemo(() => {
        if (!dataResult.data) {
            return undefined;
        }
        const chartDataJson = get(dataResult.data, dataPath);
        if (!chartDataJson) {
            throw new Error(`Could not get data at path ${dataPath}`);
        }
        return JSON.parse(chartDataJson);
    }, [dataResult, dataPath]);
    return (React.createElement("div", { className: className },
        dataResult.error && (React.createElement(ChartRequestError, { dataType: chartType, reportField: last(dataPath.split('.')), error: getAppSyncError(dataResult.error, dataPath) })),
        dataResult.loading && React.createElement(Skeleton, { active: true }),
        dataResult.data && children(parsedResult)));
};
